module.exports = {
      id: "like-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#like-usage",
      toString: function () {
        return this.url;
      }
    }